import { render, staticRenderFns } from "./Select-Input.vue?vue&type=template&id=72dec674&"
import script from "./Select-Input.vue?vue&type=script&lang=js&"
export * from "./Select-Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports